<template>
  <div class="user-manage">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px">
          <el-row :gutter="20">
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('sys.userList.userName')" prop="name">
                <el-input class="handle-input" v-model="queryCondition.name" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('sys.userList.userCd')" prop="emplid">
                <el-input class="handle-input" v-model="queryCondition.emplid" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('sys.userList.supplierCode')" prop="supplierCode">
                <el-input class="handle-input" v-model="queryCondition.supplierCode" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('sys.userList.email')" prop="email">
                <el-input class="handle-input" v-model="queryCondition.email" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('sys.userList.userType')" prop="emplFlag">
                <ic-select table="TM_USER" field="USER_TYPE" v-model="queryCondition.emplFlag" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item label="创建时间从" prop="createDateFrom">
                <el-date-picker v-model="queryCondition.createDateFrom" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item label="创建时间至" prop="createDateTo">
                <el-date-picker v-model="queryCondition.createDateTo" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
            <el-button type="primary" @click="restQueryForm()">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row>
        <el-button type="primary" v-acl="UserSyscUserFromPortal" @click="syncBossUser">同步BOSS用户</el-button>
        <!-- <el-button type="primary" v-acl="UserSyscUserFromPortal" @click="syncUser">同步CCA用户</el-button> -->
      </el-row>
      <el-table :data="tableData" border highlight-current-row max-height="450" style="margin-top:20px;">
        <el-table-column show-overflow-tooltip fixed sortable prop="name" :label="$t('sys.userList.userName')"></el-table-column>
        <el-table-column show-overflow-tooltip fixed prop="emplid" :label="$t('sys.userList.userCd')"></el-table-column>
        <el-table-column show-overflow-tooltip fixed prop="pid" label="人员编码"></el-table-column>
        <el-table-column show-overflow-tooltip fixed prop="supplierCode" :label="$t('sys.userList.supplierCode')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="email" :label="$t('sys.userList.email')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="phone" :label="$t('sys.userList.phone')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="userWorkLanguage" :label="$t('sys.userList.Language')">
          <template slot-scope="scope">{{scope.row.userWorkLanguage=='zh_CN'?'中文':'英文'}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="role" :label="$t('sys.userList.userType')">
          <template slot-scope="scope">{{scope.row.haveStore=='Y'?'STORE':scope.row.emplFlag|ic("TM_USER","USER_TYPE")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="isAllowLoginSystem" label="人员状态">
          <template slot-scope="scope">{{scope.row.isAllowLoginSystem | ic('TM_USER','IS_ALLOW_LOGIN_SYSTEM')}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createDate" label="创建时间"></el-table-column>
        <el-table-column :label="$t('common.operation')" width="180px">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" v-acl="UserEdit" @click="editUserInfo(scope.row)">{{$t('common.edit')}}</el-button>
            <el-button v-acl="UserRoleAdd" @click.native.prevent="userRoleEdit(scope.row.tmUserId)" type="primary" size="mini">{{$t('sys.userList.addRole')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
    </div>
    <el-dialog :title="$t('sys.userList.userInfo')" :visible.sync="showUserInfo" width="70%" :close-on-click-modal="false" @closed="closeUserInfo" class="userInfo_dialog">
      <el-form :model="userInfo" ref="userInfoForm" :rules="userRules" :label-position="labelPosition" label-width="100px">
        <div class="title_box">
          <p class="line"></p>
          <p class="title">用户信息</p>
        </div>
        <div class="user_info">
          <div class="personal_img">
            <el-avatar :size="300" :src="imageUrl"></el-avatar>
            <el-upload class="avatar-uploader" ref="upload" :action="fileUploadUrl(userInfo.tmUserId)" :show-file-list="false" :on-success="(response, file, fileList)=> uploadSuccess(userInfo.tmUserId, response, file, fileList)" :headers="header" :before-upload="beforeAvatarUpload">
              <el-button size="small" type="primary" class="el-icon-upload searhBtn">上传电子签名</el-button>
            </el-upload>
          </div>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="用户名" prop="name">
                <el-input v-model="userInfo.name" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="用户账号" prop="emplid">
                <el-input v-model="userInfo.emplid" disabled placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="userInfo.phone" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="userInfo.email" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="语言" prop="userWorkLanguage">
                <el-select v-model="userInfo.userWorkLanguage" clearable style="width: 100%">
                  <el-option :label="$t('common.sel')" value></el-option>
                  <el-option key="1" value="zh_CN" label="中文"></el-option>
                  <el-option key="2" value="en_US" label="英文"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Leader">
                <pickup-user @change="changeLeader" :default-value="userInfo.leaderName" style="width:100%"></pickup-user>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="供应商Code" prop="supplierCode">
                <el-input v-model="userInfo.supplierCode" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属实验室" prop="laboratory">
                <ic-select table="TM_USER" field="LABORATORY" v-model="userInfo.laboratory" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="this.emplFlag === 'MCD'">
              <el-form-item label="QIP_DC" prop="dcCodes">
                <el-select v-model="userInfo.dcCodes" clearable multiple placeholder="请选择(支持多选)" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in QipcdList" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="title_box" v-if="emplFlag==='SUP'">
          <p class="line"></p>
          <p class="title">数据权限</p>
        </div>
        <div class="user_info" v-if="emplFlag==='SUP'">
          <el-row :gutter="24">
            <el-col>
              <table class="user_table">
                <tr>
                  <td class="title">模块</td>
                  <td class="title">权限值</td>
                </tr>
                <tr>
                  <td>HGS供应商、RMC采购量</td>
                  <td>
                    <el-form-item label-width="0">
                      <ic-select table="TM_USER" field="DATA_SCOPE" v-model="userInfo.dataScope" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>StoreFeedBack</td>
                  <td>
                    <el-form-item label-width="0">
                      <ic-select table="TM_USER" field="DATA_SCOPE_TYPE_FEEDBACK" v-model="userInfo.feedBackDataScope" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>Sensory</td>
                  <td>
                    <el-form-item label-width="0">
                      <ic-select table="TM_USER" field="DATA_SCOPE_TYPE_SENSORY" v-model="userInfo.sensoryDataScope" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>Nutrition</td>
                  <td>
                    <el-form-item label-width="0">
                      <ic-select table="TM_USER" field="NUTRITION_DATA_SCOPE" v-model="userInfo.nutritionDataScope" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </td>
                </tr>
              </table>
            </el-col>
          </el-row>
        </div>
        <el-row type="flex" justify="center" style="margin-top:5px">
          <el-button type="primary" @click="showUserInfo = false">{{$t('common.close')}}</el-button>
          <el-button type="primary" @click="saveUserInfo">{{$t('common.save')}}</el-button>
        </el-row>
        <!-- <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item :label="$t('sys.userList.userName')" placeholder prop="name">
              <el-input v-model="userInfo.name" style="width:100%" />
            </el-form-item>
            <el-form-item :label="$t('sys.userList.userCd')" placeholder>
              <el-input v-model="userInfo.emplid" disabled="true" style="width:100%" />
            </el-form-item>
            <el-form-item :label="$t('sys.userList.email')" placeholder prop="email">
              <el-input v-model="userInfo.email" style="width:100%" />
            </el-form-item>
            <el-form-item :label="$t('sys.userList.phone')" placeholder prop="phone">
              <el-input v-model="userInfo.phone" style="width:100%" />
            </el-form-item>
            <el-form-item :label="$t('sys.userList.Language')" placeholder>
              <el-select v-model="userInfo.userWorkLanguage" style="width:100%">
                <el-option :label="$t('common.sel')" value></el-option>
                <el-option key="1" value="zh_CN" label="中文"></el-option>
                <el-option key="2" value="en_US" label="英文"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Leader">
              <pickup-user @change="changeLeader" :default-value="userInfo.leaderName" style="width:100%"></pickup-user>
            </el-form-item>
            <el-form-item label="权限" v-if="emplFlag==='SUP'">
              <ic-select table="TM_USER" field="DATA_SCOPE" v-model="userInfo.dataScope" style="width:100%"></ic-select>
            </el-form-item>
            <el-form-item :label="$t('sys.userList.UploadSignature')">
              <el-upload class="avatar-uploader" :action="fileUploadUrl(userInfo.tmUserId)" :show-file-list="false" :on-success="(response, file, fileList)=> uploadSuccess(userInfo.tmUserId, response, file, fileList)" :headers="header" :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-button size="mini" type="primary" v-if="imageUrl" class="deleteFile" @click="deleteFile(userInfo.tmUserId)">删除</el-button>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </el-dialog>
    <!--=========用户信息END================-->
    <!--=========用户角色配置================-->
    <el-dialog :title="$t('sys.userList.roleSelection')" :visible.sync="showUserRole" width="60%">
      <div style="text-align: center">
        <el-transfer style="text-align: left; display: inline-block" filterable v-model="selRoles" :data="notSelRoles" :titles="[$t('sys.userList.roleSource'), $t('sys.userList.roleTarget')]"></el-transfer>
      </div>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="showUserRole = false">{{$t('common.close')}}</el-button>
        <el-button type="primary" @click="saveUserRole">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
    <!--=========用户角色配置END================-->
  </div>
</template>
<script>
import { userService } from "../../../api/user-manage/user";
import { fileService } from "@/api/common/file-utils";
import { Message } from "element-ui";
import QIPApi from "@/api/QIP/index";
import commonFunction from "../../../utils/dataTableUtils";
import commonConstants from "@/constants/commonConstants";
import commonFun from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";
import PickupUser from "@/components/common/pickupUser";
// 验证手机
let checkPhone = (rule, value, callback) => {
  if (value != "" && value != null) {
    let reg = /^1[345789]\d{9}$/;
    if (!reg.test(value)) {
      callback(new Error('请输入11位有效手机号号码')); //请输入11位手机号
    } else {
      callback();
    }
  } else {
    callback();
  }
};
export default {
  name: "user-manage",
  components: { PickupUser, IcSelect },
  data() {
    return {
      isShow: false,
      imageUrl: "",
      filesList: [],
      tableData: [],
      totalCount: 0,
      labelPosition: "right",
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        supplierCode: '',
        name: "",
        emplid: "",
        email: "",
        emplFlag: "",
        createDateFrom: "",
        createDateTo: ""
      },
      header: {
        "x-access-token": localStorage.getItem("token")
      },
      showUserRole: false,
      notSelRoles: [],
      QipcdList: [],
      selRoles: [],
      userId: null,
      userInfo: {
        leaderId: null,
      },
      showUserInfo: false,
      emplFlag: '',
      userRules: {
        name: [
          {
            required: true,
            message: this.$t("sys.userList.inputName"),
            trigger: "blur"
          }
        ],
        phone: [{ type: "number", validator: checkPhone, trigger: ["blur"] }],
        email: [
          {
            type: "email",
            message: this.$t("sys.userList.inputEmail"),
            trigger: ["blur"]
          }
        ]
      }
    };
  },
  created() {
    this.queryData(1);
    var supplierObj = JSON.parse(localStorage.getItem('supplierObj'))
    console.log('supplierObj', supplierObj);
    if (supplierObj) {
      this.isShow = true
    } else {
      this.isShow = false
    }
  },
  methods: {
    fileUploadUrl(bizId) {
      if (commonFun.isNotEmpty(bizId) && bizId > 0) {
        return commonConstants.fileUploadUrl + `/USER_SIGN/SIGN/${bizId}`;
      } else {
        return commonConstants.fileUploadUrl;
      }
    },
    uploadSuccess(id, response, file, fileList) {

      console.log(response)
      console.log(file)
      console.log(fileList)
      console.log(id)
      // console.log(value)
      // let tmDocumentId = response.data[0].tmDocumentId
      // fileService.deleteFile(tmDocumentId).then(res => {});
      this.imageUrl = URL.createObjectURL(file.raw);

      let attachment = {};
      attachment.seq = "SIGN";
      attachment.tsRecId = id;
      attachment.tsReckindId = "USER_SIGN";
      fileService.getFileList(attachment).then(fileRes => {
        //上传成功后 删除上次上传的
        if (fileRes.length > 1) {
          let tmDocumentId = fileRes[0].tmDocumentId
          fileService.deleteFile(tmDocumentId).then(res => { });
        }

      });
    },
    syncBossUser() {
      userService.syncPostUser().then(response => {
        console.log("GY🚀 ~ file: user-manage.vue:363 ~ userService.syncPostUser ~ response:", response);
        Message.success(this.$t("sys.userList.syscMessage"));
      });
    },
    syncUser() {
      userService.syncUser().then(response => {
        Message.success(this.$t("sys.userList.syscMessage"));
      });
    },
    // 获取QIP_DC编号
    getQspiDcList() {
      QIPApi.getDcMasterData({
        auditStatus: "approve",
        pageSize: -1,
      }).then(res => {
        this.QipcdList = [];
        const listData = res.resultData;
        listData.forEach(ele => {
          const temp = {
            value: ele.supplierCode,
            label: ele.supplierName
          }
          this.QipcdList.push(temp)
        })
      })
    },
    changeLeader(user) {
      let that = this;
      this.userInfo.leaderId = user.tmUserId;
      userService.setLeaderByUserId({
        tmUserId: this.userInfo.tmUserId,
        relationType: "Leader",
        relateUserId: user.tmUserId
      }).then(res => {
        if (res.code == 200) {
          Message.success(this.$t("common.operateSuccess"));
        }
      });
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      userService.getUsers(this.queryCondition).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    //用户角色设置
    userRoleEdit(userId) {
      userService.getUserRole(userId).then(res => {
        (this.notSelRoles = res.data.allRole),
          (this.selRoles = res.data.sel),
          (this.showUserRole = true);
        this.userId = userId;
      });
    },
    //保存用户角色
    saveUserRole() {
      userService.saveRole(this.selRoles, this.userId).then(res => {
        if (res.meta.success) {
          Message({ message: this.$t("common.saveSuccess"), type: "success" });
        } else {
          Message({ message: this.$t("common.saveError"), type: "error" });
        }
      });
    },
    editUserInfo(row) {
      let id = row.tmUserId;
      this.emplFlag = row.emplFlag
      this.userInfo = {};
      this.clearVlidate("userInfoForm");
      let current = row;
      if (current.dcCodes && current.dcCodes.length > 0) {
        current.dcCodes = current.dcCodes.split(",")
      } else {
        current.dcCodes = []
      }
      this.userInfo = current;
      this.showUserInfo = true;
      let _this = this;
      _this.userInfo.leaderId = null;
      _this.userInfo.leaderName = null;
      userService.getLeaderByUserId(id, 'Leader').then(res => {
        if (res.code == 200) {
          let leader = res.data[0];
          _this.userInfo.leaderId = leader.tmUserId;
          _this.userInfo.leaderName = leader.name;
        }
      })
      _this.getQspiDcList();
      //获取上传的麦中供应链QS批准图片
      this.docIdToUrl(id);
    },
    docIdToUrl(id) {
      let that = this;
      let attachment = {};
      attachment.seq = "SIGN";
      attachment.tsRecId = id;
      attachment.tsReckindId = "USER_SIGN";
      fileService.getFileList(attachment).then(fileRes => {
        let len = fileRes.length;
        if (len > 0) {
          that.imageUrl = "/adminconsole/file/downloadByKey?key=" + fileRes[len - 1].documentKey;
        } else {
          that.imageUrl = "";
        }
      });
    },
    saveUserInfo() {
      let validFlag = false;
      this.$refs["userInfoForm"].validate(valid => {
        validFlag = valid;
      });
      if (!validFlag) {
        return;
      }
      this.imageUrl = "";
      let params = Object.assign({}, this.userInfo)
      if (params.dcCodes && params.dcCodes.length > 0) {
        params.dcCodes = params.dcCodes.join(",")
      } else {
        params.dcCodes = null;
      }
      userService.saveUserInfo(params).then(res => {
        if (res.meta.success) {
          Message({ message: this.$t("common.saveSuccess"), type: "success" });
          this.showUserInfo = false;
        } else {
          Message({ message: this.$t("common.saveError"), type: "error" });
        }
      });
    },
    //文件删除
    deleteFile: function (tmUserId) {
      let that = this;
      let attachment = {};
      attachment.seq = "SIGN";
      attachment.tsRecId = tmUserId;
      attachment.tsReckindId = "USER_SIGN";
      fileService.getFileList(attachment).then(fileRes => {
        let tmDocumentId = fileRes[fileRes.length - 1].tmDocumentId;
        console.log(fileRes.length);
        console.log(tmDocumentId);
        fileService.deleteFile(tmDocumentId).then(res => {
          that.$message({
            type: "success",
            message: that.$t("common.delSuccess")
          });
          //删除成功删除列表数据
          that.docIdToUrl(tmUserId);
        });
      });
    },
    closeUserInfo() {
      this.queryData();
      this.imageUrl = "";
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    }
  },
  extends: commonFunction
};
</script>
<style lang="scss">
.user-manage {
  .deleteFile {
    margin-top: 40px;
    margin-left: 10px;
  }
  .avatar-uploader .el-upload {
    border: 1px solid #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    float: left;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .handle-input {
    width: 95%;
  }
  .form_border {
    border: 1px solid #eaeefb;
    padding: 10px 10px 0;
  }

  /*穿梭框样式重写*/
  .el-transfer .el-transfer-panel {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    display: inline-block;
    vertical-align: middle;
    width: 300px;
    max-height: 100%;
    box-sizing: border-box;
    position: relative;
    padding-bottom: 40px;
  }
  .el-transfer-panel__body {
    height: 370px;
  }
  .el-transfer-panel__list.is-filterable {
    height: 360px;
  }
}
</style>
